import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import ReactDragList from 'react-drag-list';
import { toast, ToastContainer} from 'react-toastify';
import {Button, Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';

import withServices  from '../../../../HOCs/withServices';
import Navbar from '../../../../components/CustomNav/CustomNav.Component'; 

import FormModal from '../../../../components/Admin/FormModal/FormModal';
import FormFieldClass from '../../../../components/Admin/FormModal/FormFieldClass';

import { ModalWrapper, Wrapper, Content, ContentCol,ContentRow, ContentRowSingleCol, StyledSectionHeader} from './Assessment.styles';
import 'react-drag-list/assets/index.css';

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
  }
  
  interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
  }

class NormalAssessment extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.courselessonSubmit = this.courselessonSubmit.bind(this);
        this.courseLessonToggle = this.courseLessonToggle.bind(this);
        this.courselessonOrderSubmit = this.courselessonOrderSubmit.bind(this);
        this.courselessonDelete = this.courselessonDelete.bind(this);
        this.goToCourseLesson = this.goToCourseLesson.bind(this);
        this.goToPreview = this.goToPreview.bind(this);
    }
 
    public onGoBack() {
        
        const dest = this.props.services.currentBaseUrl + 'courses'
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public goToPreview () {
        const dest = this.props.services.currentBaseUrl + 'course_preview/' + this.state.data.AssessmentID
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public setTab(param, e) {
        const data = this.state.data
        data.activetab = param;
        this.setState({
            data
         });
    }

    public dragComplete(e) {
        console.log(e);
    }

    public courseLessonToggle() {
        const data = this.state.data
        data.courselessonmodal = !data.courselessonmodal;
        this.setState({
            data
         });
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: AssessmentID } } = match;

        const assessmentDataKey = ["id", "Question", "Group","Created","delete"];
        
        const assessmentThead = ["ID", "Question", "Group", "Created", "Action"];

        const questionsRes = await adminAPI.getAssessmentQuestionsPlusAnswers(AssessmentID);
        
        if (questionsRes.ok) {
            
            const allQuestions = questionsRes.data.questions;
        
            
            this.setState(
                {
                     data: {
                         activetab: '1',
                         allQuestions,
                         assessmentDataKey,
                         assessmentThead,
                         courselessonmodal: false,
                         AssessmentID
                     }
                }
                );
          } else {
            toast.error('Error fetching course details!');
          }
    }

    public customTD = props =>{
        return (
          <td>
            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.goToCourseLesson(props)}>Edit</button>

            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.courselessonDelete(props)}>Delete</button>
          </td>
        );
    } 

    public async courselessonOrderSubmit() {

        const data = this.state.data
        
        this.setState({
            loaded: false
         });

        const item = {
            DisplayItems: JSON.stringify(data.courselessons),
        }

        const res = await this.props.services.adminAPI.updateCourseLessonOrder(item);

        if (res.ok) {
            const AssessmentID = this.state.data.AssessmentID;

            const courseLessonRes = await this.props.services.adminAPI.getCurrentCourseLessons({ AssessmentID});
            
            if(courseLessonRes.ok) {
                const data = this.state.data;

                data.courselessons = courseLessonRes.data.course_lessons;
            
                this.setState({
                    data
                 });
            }
        }
        else{
            toast.error('Error updating order!');
        }

        this.setState({
            loaded: true
         });
    }

    public async goToCourseLesson(row) {
        console.log(row);
        const dest = this.props.services.currentBaseUrl + 'course_lessons/' + row.rowData.id
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public async courselessonDelete(row) {
        const retVal = confirm("Do you want to continue ?");
        if(!retVal) {
            return;
        }  

        this.setState({
            loaded: false
         });

        const item = row.rowData;

        const res = await this.props.services.adminAPI.deleteItemGeneral('course_lessons', item.id);

        if (res.ok) {
            const AssessmentID = this.state.data.AssessmentID;

            const courseLessonRes = await this.props.services.adminAPI.getCurrentCourseLessons({ AssessmentID});
            
            if(courseLessonRes.ok) {
                const data = this.state.data;

                data.courselessons = courseLessonRes.data.course_lessons;

                 this.setState({
                    data,
                    loaded: true
                 });
            }
        }
        else{
            toast.error('Error deleting item!');
        }

    }

    public async courselessonSubmit(e) {

        e.preventDefault();

        this.setState({
            loaded: false
         });

        const item = this.state.data.lessonFormValues;

        const res = await this.props.services.adminAPI.createItemGeneral('course_lessons', item);

        if (res.ok) {
            this.courseLessonToggle();

            const AssessmentID = this.state.data.AssessmentID;

            const courseLessonRes = await this.props.services.adminAPI.getCurrentCourseLessons({ AssessmentID});
            
            if(courseLessonRes.ok) {
                const data = this.state.data;

                data.courselessons = courseLessonRes.data.course_lessons;
            
                this.setState({
                    data
                 });
            }
        }
        else{
            toast.error('Error creating item!');
        }

        this.setState({
            loaded: true
        });
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                 </ContentRow>

                <ContentRowSingleCol className="single-col">
                    <Nav tabs={true} style={{flexWrap: 'nowrap'}}>
                        <NavItem >
                            <NavLink onClick={this.setTab.bind(this, '1')}>
                                Questions
                            </NavLink>
                            
                        </NavItem>
                        <NavItem >
                            <NavLink onClick={this.setTab.bind(this, '2')}>
                                Order
                            </NavLink>
                        </NavItem>
                    </Nav>
                </ContentRowSingleCol>

                <ContentRowSingleCol>
                <Loader color="#acff24" loaded={this.state.loaded}/>

                <TabContent activeTab={data.activetab}>

                    <TabPane tabId="1">
                        
                        <StyledSectionHeader>Course Lessons</StyledSectionHeader>
                        <Button onClick={this.courseLessonToggle}>Add New</Button>

                        <Button style={{marginLeft: '5px'}} onClick={this.goToPreview}>Preview</Button>

                        <SortableTbl
                            tblData={data.allQuestions}
                            tHead={data.assessmentThead}
                            dKey={data.assessmentDataKey}
                            customTd={[
                                { custd: this.customTD, keyItem: "edit", sortable: false },
                                { custd: this.customTD, keyItem: "delete", sortable: false }
                            ]}
                            defaultCSS={false}
                        />
                    </TabPane>

               

                </TabContent>
                </ContentRowSingleCol>
                
                
              </Content>
            </Wrapper>  
        )
    }
}

export default withServices(NormalAssessment);


// WEBPACK FOOTER //
// ./src/pages/Admin/Assessments/Assessment/NormalAssessment.tsx